import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  that = this;
  // preventHandler2: any;

  constructor(
    private router: Router,
  ) {}

  ngOnInit() {
    // this.preventHandler2 = this.preventHandler.bind(this);
    // // disable right click
    // document.addEventListener('contextmenu', event => event.preventDefault());
    // document.addEventListener('contextmenu', this.preventHandler2);
    // document.addEventListener('keydown', this.preventHandler2);
    // 为了打开分享页面
    const hash = (localStorage.getItem('hash') || '').slice(1);
    localStorage.removeItem('hash');
    // 如果有对应的路径，那么就直接导航过去
    // 如果是分享的，那么直接导航到分享页面
    if (hash && hash.startsWith('/share')) {
      this.router.navigateByUrl(hash);
    }
  }

  // 不能实现，待考究
  // preventHandler(e) {
  //   // disable F12 key
  //   if (e.keyCode == 123) {
  //       return false;
  //   }
  //   // disable I key
  //   if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
  //       return false;
  //   }
  //   // disable J key
  //   if (e.ctrlKey && e.shiftKey && e.keyCode == 74) {
  //       return false;
  //   }
  //   // disable U key
  //   if (e.ctrlKey && e.keyCode == 85) {
  //       return false;
  //   }
  //   if (e.ctrlKey && e.shiftKey && e.keyCode == 65) {
  //     document.removeEventListener('keydown', this.preventHandler2);
  //     document.removeEventListener('contextmenu', () => true );
  //   }
  //   return false;
  // }
}
